import { BuildingType } from "../../types/references/BuildingType"
import { IconName } from "../../ui/icon/__generated__/IconName"

/**
 * Maps BuildingType enum values to their corresponding IconName values
 */
export const BUILDING_TYPE_ICON_MAP: Record<BuildingType, IconName> = {
  [BuildingType.AIRPORT]: IconName.BUILDING_TYPE_AIRPORT,
  [BuildingType.OFFICE_BUILDING]: IconName.BUILDING_TYPE_OFFICE_BUILDING,
  [BuildingType.CHEMISTRY_PHARMA]: IconName.BUILDING_TYPE_CHEMISTRY_PHARMA,
  [BuildingType.SHOPPING_MALL]: IconName.BUILDING_TYPE_SHOPPING_MALL,
  [BuildingType.INDUSTRIAL_HALL]: IconName.BUILDING_TYPE_INDUSTRIAL_HALL,
  [BuildingType.MEDICAL_PRACTICE]: IconName.BUILDING_TYPE_MEDICAL_PRACTICE,
  [BuildingType.HOSPITAL]: IconName.BUILDING_TYPE_HOSPITAL,
  [BuildingType.HOTEL]: IconName.BUILDING_TYPE_HOTEL,
  [BuildingType.CINEMA]: IconName.BUILDING_TYPE_CINEMA,
  [BuildingType.THEATER]: IconName.BUILDING_TYPE_THEATER,
  [BuildingType.FAIR]: IconName.BUILDING_TYPE_FAIR,
  [BuildingType.MUSEUM]: IconName.BUILDING_TYPE_MUSEUM,
  [BuildingType.CHURCH]: IconName.BUILDING_TYPE_CHURCH,
  [BuildingType.RESTAURANT]: IconName.BUILDING_TYPE_RESTAURANT,
  [BuildingType.SCHOOL]: IconName.BUILDING_TYPE_SCHOOL,
  [BuildingType.UNDERGROUND_CAR_PARK]:
    IconName.BUILDING_TYPE_UNDERGROUND_CAR_PARK,
  [BuildingType.SPORTS_FACILITY]: IconName.BUILDING_TYPE_SPORTS_FACILITY,
  [BuildingType.RECORDING_STUDIO]: IconName.BUILDING_TYPE_RECORDING_STUDIO,
  [BuildingType.ASSEMBLY_BUILDING]: IconName.BUILDING_TYPE_ASSEMBLY_BUILDING,
  [BuildingType.RESIDENTIAL_BUILDING]:
    IconName.BUILDING_TYPE_RESIDENTIAL_BUILDING
}

/**
 * Returns the corresponding IconName for a given BuildingType
 * @param buildingType - The building type to get the icon for
 * @returns The corresponding IconName
 */
export function getBuildingTypeIcon(buildingType: BuildingType): IconName {
  return BUILDING_TYPE_ICON_MAP[buildingType]
}
